/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment, PureComponent } from 'react'
import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
  path {
    fill: ${theme.color.themeTxt};
  }
`
export default class TrashIco extends PureComponent {
  render() {
    return (
      <Fragment>
        <svg
          id="_x34__19_"
          xmlns="http://www.w3.org/2000/svg"
          width="42"
          height="51.692"
          viewBox="0 0 42 51.692"
          css={Color}
        >
          <g id="그룹_3761" data-name="그룹 3761" transform="translate(0)">
            <path
              id="패스_3729"
              data-name="패스 3729"
              d="M99.693,45.231a1.616,1.616,0,0,0,1.615-1.615V24.231a1.615,1.615,0,1,0-3.231,0V43.615A1.616,1.616,0,0,0,99.693,45.231Zm9.692-38.769H99.693V3.231A3.23,3.23,0,0,0,96.462,0H86.77a3.23,3.23,0,0,0-3.231,3.231V6.462H73.847a3.23,3.23,0,0,0-3.231,3.231v3.231a3.231,3.231,0,0,0,3.231,3.231V45.231a6.462,6.462,0,0,0,6.462,6.461h22.615a6.462,6.462,0,0,0,6.461-6.461V16.154a3.231,3.231,0,0,0,3.231-3.231V9.692A3.23,3.23,0,0,0,109.385,6.462ZM86.77,4.846a1.616,1.616,0,0,1,1.615-1.615h6.462a1.616,1.616,0,0,1,1.615,1.615V6.462H86.77Zm19.385,40.385a3.231,3.231,0,0,1-3.231,3.231H80.308a3.231,3.231,0,0,1-3.231-3.231V16.154h29.077Zm1.615-32.308H75.462a1.615,1.615,0,0,1,0-3.231H107.77a1.615,1.615,0,0,1,0,3.231ZM83.539,45.231a1.616,1.616,0,0,0,1.615-1.615V24.231a1.615,1.615,0,1,0-3.231,0V43.615A1.616,1.616,0,0,0,83.539,45.231Zm8.077,0a1.616,1.616,0,0,0,1.615-1.615V24.231a1.615,1.615,0,1,0-3.231,0V43.615A1.616,1.616,0,0,0,91.616,45.231Z"
              transform="translate(-70.616)"
              fill="#eee"
            />
          </g>
        </svg>
      </Fragment>
    )
  }
}
